import { FaExternalLinkAlt } from 'react-icons/fa';

import { IAlert } from '@/store/ducks/products/types';

import Price from '../price/Price';

export const pbmHeaders = (selectedPromotion: IAlert | undefined, color: string) => {
  // eslint-disable-next-line radix
  const discount_percentage = parseInt(selectedPromotion?.max_discount_percentage || '0', 10);
  return {
    Product: () => (
      <div
        className="pbm-card-header flex-md-row align-items-center justify-content-center"
        style={{ backgroundColor: color, borderColor: color }}
      >
        <span className="text-center justify-content-center">
          <strong>Até {discount_percentage}% de desconto</strong>
        </span>
      </div>
    ),
    Default: () => (
      <div
        className="pbm-card-header flex-md-row  smaller-text gap-1"
        style={{ backgroundColor: color, borderColor: color }}
      >
        <span>Desconto de Lab</span>
        <strong> até {discount_percentage}% de desconto</strong>
      </div>
    ),
  };
};

export const pbmBody = (
  selectedPromotion: IAlert | undefined,
  showPbmPromotionsModal: (show: boolean) => void,
  price: number,
) => {
  const discountPrice =
    selectedPromotion?.price ||
    price - (price * Number(selectedPromotion?.max_discount_percentage)) / 100;

  return {
    Product: () => (
      <>
        <div className="d-flex flex-row justify-content-between">
          {selectedPromotion?.laboratory_image ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                maxHeight: '5.75rem',
                maxWidth: '5.75rem',
                height: '4.5rem',
                width: '4.5rem',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
              }}
            >
              <img
                src={selectedPromotion?.laboratory_image}
                style={{ width: 100, height: 80, objectFit: 'contain', padding: '1rem' }}
                alt="Laboratório"
              />
            </div>
          ) : null}
          <div className="d-flex flex-column pl-2" style={{ maxWidth: '14rem' }}>
            <strong style={{ fontSize: '0.8rem' }}>DESCONTO DE LABORATÓRIO</strong>
            <span
              className="d-flex flex-row justify-content-between"
              style={{ fontSize: '0.75rem' }}
            >
              <button
                onClick={() => showPbmPromotionsModal(true)}
                style={{
                  border: 'none',
                  color: '#007bff',
                  backgroundColor: 'transparent',
                }}
              >
                Saiba mais <FaExternalLinkAlt />
              </button>
              <span>A unidade sai por: </span>
            </span>
            <div className="d-flex align-items-end pb-1">
              <Price price={discountPrice} defaultPrice={discountPrice} />
            </div>
          </div>
        </div>
      </>
    ),
    Default: () => (
      <>
        <span className="smaller-text">A unidade sai por:</span>
        <div className="p-2 pr-3 row">
          <Price price={discountPrice} defaultPrice={discountPrice} />
        </div>
      </>
    ),
  };
};
